<script lang="ts">
    import type {Document, FieldTypeId, Fond} from 'typings/portaro.be.types';
    import type {FondFieldRelationLink} from 'src/features/record/kp-related-records-table/types';
    import {onMount} from 'svelte';
    import {getInjector} from 'core/svelte-context/context';
    import {KpRelatedRecordsTablePresenter} from './kp-related-records-table.presenter';
    import {createRelationsContext} from 'src/features/record/kp-related-records-table/relations.context';
    import {exists} from 'shared/utils/custom-utils';
    import KpRecordGrid from '../../record-grid/KpRecordGrid.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import RelationsRowOptionsCell from 'src/features/record/kp-related-records-table/RelationsRowOptionsCell.svelte';
    import {isNotEmpty} from 'shared/utils/array-utils';

    export let record: Document;
    export let fondId: number;
    export let referenceFieldTypeId: FieldTypeId | null = null;
    export let originReferenceFieldTypeId: FieldTypeId | null = null;
    export let relations: FondFieldRelationLink[] | null = null;

    const presenter = getInjector().getByClass(KpRelatedRecordsTablePresenter);
    let loading = true;
    let fonds: Fond[] = [];

    onMount(async () => {
        fonds = await presenter.getCompatibleFonds(fondId);
        loading = false;
    });

    createRelationsContext(relations ?? []);
</script>

{#if loading}
    <KpLoadingBlock/>
{/if}

{#if !loading && fonds.length > 0}
    <KpRecordGrid referenceRecordId={record.id}
                  {...exists(relations) && isNotEmpty(relations) ? {rowOptionsCellComponent: RelationsRowOptionsCell} : {}}
                  fondOrFondId={fonds.at(0)}
                  relatedFonds={fonds}
                  {referenceFieldTypeId}
                  {originReferenceFieldTypeId}/>
{/if}